/**
 * @file src/plugins/marathonPaths.js
 * @description Marathon Photos API path configuration.
 *
 * Installs `this.$marathonPaths` on all Vue instances, providing
 * the base URLs for every API endpoint the Event components call.
 *
 * Switches between production and development URLs based on NODE_ENV.
 */

// TODO REMOVE PORT FROM GETEVENT BEFORE GOING LIVE WITH THIS
const prodPaths = {
  searchEvents: 'https://api.marathon-photos.com/website_api/v7/search?group=Sports',
  getEvent: 'https://api.marathon-photos.com:8443/website_api/v11/commercial_details?event=',
  getEventDetails: 'https://api.marathon-photos.com/website_api/v7/details?event=',
  getEventBibs: 'https://api.marathon-photos.com/website_api/v7/search?limit=100&event=',
  morephotos: 'https://api.marathon-photos.com/website_api/v7/find_more_photos_doomscroll?event=',
  tagphoto: 'https://api.marathon-photos.com/website_api/v7/tag_photo',
  untagphoto: 'https://api.marathon-photos.com/website_api/v7/untag_photo',
  getbyLocation:
    'https://marathon-photos.com/scripts/load.py/logic?logic=GetPhotosByLocation&template=MPX2',
  getCrop: 'https://api.marathon-photos.com/website_api/v7/crop?event=',
  previewCrop: 'https://api.marathon-photos.com/make_image/v1/make?event=',
  photoServer: 'https://static.marathon-photos.com/photos/',
  streamProduct: 'https://marathon-photos.com/logics/StreamProduct?event=',
  getMyOrder: 'https://api.marathon-photos.com/download/get?order_id=',
  contactUsForm: 'https://cs.marathonphotos.live/api/v3/tickets',
  getShareToken: 'https://api.marathon-photos.com/website_api/v7/get_share_token?event=',
  getShareDetails: 'https://api.marathon-photos.com/website_api/v7/details?token=',
  editShareToken: 'https://api.marathon-photos.com/website_api/v7/enable_share_token?token=',
  pushnotificiton: 'https://api.marathon-photos.com/website_api/v7/save_webpush_subscription',
  selfieSearch: 'https://api.marathon-photos.com/facesearch',
  selfieLogin: 'https://api.marathon-photos.com/facesearch',
  getMediaToken: 'https://api.marathon-photos.com/media/get_media_page',
};

const devPaths = {
  ...prodPaths,
  morephotos:
    'https://api.marathon-photos.com:8443/website_api/v7/find_more_photos_doomscroll?event=',
};

const paths = process.env.NODE_ENV === 'production' ? prodPaths : devPaths;

export default {
  install(Vue) {
    Vue.prototype.$marathonPaths = paths;
  },
};

export { prodPaths, devPaths };
